
export const Status = {
    Active: "active",
    Inactive: "inactive",
    ActiveLab: "activelab"
}

export const NoSubmission = "No submission"


// Screen size breakpoints.
// These can be used in conjunction with the useWindowSize hook to determine the current screen size.
export const ScreenSize = {
    Small: 576,
    Medium: 768,
    Large: 992,
    TailwindLg: 1024,
    ExtraLarge: 1200
}
